import { ClientMotorRequest } from '../models/ClientMotorRequest';

export const CLIENT_MOTOR_REQUEST: ClientMotorRequest = {
    nN: 1488.0,
    speed: 1500.0,
    mlfb: '1LE1603-3AB53-4AQ4',
    options: 'B43',
    language: 'en',
    lineFrequency: 50.0,
    lineVoltage: 400.0,
    pn: 200.0,
    efficiencyClass: 'IE3',
    voltageCode: '34',
    winding: {
        en: 'EN_400+VΔ+/+690+VY+50Hz,+460+VΔ+60Hz',
        de: 'DE_400+VΔ+/+690+VY+50Hz,+460+VΔ+60Hz'
    },
    explosionProtection: {
        en: 'without (Safe Area)',
        de: ''
    },
    frameMaterial: {
        en: '',
        de: 'LANG_Cast iron'
    },
    frameSize: '315L',
    poleNumber: 4.0,
    tStartWarm: 39.3,
    tStartCold: 69.3,
    tBlockMaxWarm: 25.1,
    tBlockMaxCold: 44.3,
    heatingTimeT1T2: 50.0,
    heatingTimeT3: 60.0,
    motorType: {
        en: 'Innomotics SD',
        de: ''
    },
    maMn: 3.2,
    connectionType: 1,
    mkMn: 3.0,
    mn: 1280.0,
    ms: 2.3,
    ns: 1150.0,
    iaIn: 7.4,
    i0Delta: 101.0,
    i0Y: 58.55,
    j: 3.7,
    startingType: 0,
    typicalCurrent: 340.0,
    uDelta: 400,
    uy: 690.0,
    iDelta: 340.0,
    iy: 198.0,
    temperatureClass: 0,
    yDSwitchPossible: true,
    isDolOperation: false,
    isVsdOperation: false,
    vsdFramesize: 80.0,
    ventilation: 'IC411',
    vsdRatedSpeed: 1487.64,
    vsdRatedTorque: 1318.4,
    cutoffFrequency: 50
};
